import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild, AfterViewInit } from '@angular/core';
import {
    MatPaginatorIntl,
    MatPaginatorModule,
    PageEvent
} from '@angular/material/paginator';
import { PaginatorLocalizeService } from './paginator.service';

@Component({
    selector: 'lib-paginator',
    imports: [MatPaginatorModule],
    providers: [
        { provide: MatPaginatorIntl, useClass: PaginatorLocalizeService }
    ],
    templateUrl: './paginator.component.html',
    styleUrl: './paginator.component.scss'
})
export class PaginatorComponent implements AfterViewInit {
    @Input() pageSize!: number;
    @Input() pageIndex!: number;
    @Input() totalItems!: number;
    @Input() pageSizeOptions!: number[];

    @Output() pageChange = new EventEmitter<PageEvent>();
    @ViewChild('paginator', { read: ElementRef }) paginatorRef!: ElementRef;

    constructor(private renderer: Renderer2) { }

    onPageChange(event: PageEvent) {
        this.pageChange.emit(event);
    }

    ngAfterViewInit(): void {
        const touchTargetDiv = this.paginatorRef.nativeElement.querySelector('div.mat-mdc-paginator-touch-target');

        if (touchTargetDiv) {
            this.renderer.setAttribute(touchTargetDiv, 'data-testid', 'paginator-touch-target');
        }
    }
}